/*
 * @Author: cc
 * @LastEditTime: 2022-08-02 11:53:43
 */
// import { FC } from "react";
// import { Picker, List, NavBar } from "antd-mobile";
// import userDefault from "@root/img/user.png";
// import { useSelector } from "react-redux";
import {  useHistory } from "react-router-dom";
import Style from "./index.module.scss"
import logo from "@/img/logo.png"
import {LeftOutline} from  "antd-mobile-icons"
import { useEffect,useState } from "react";
import { get } from "src/component/fetch";
import { useLocation  } from "react-router-dom";
import store from "../../../../reducers"
import {connect} from "react-redux"
import { isInApp, webCallApp } from "src/utils/web-call-app";
export const useQuery = () => {
  return new URLSearchParams(useLocation().search);
};
// const leftIconSty = {
//   top: "12px",
//   left: "14px",
// };
// const userSty = {
//   width: "26px",
//   height: "26px",
// };
export const Header = (props:any) => {
  const history = useHistory();
  // const query = useQuery()
  // const subjectId = query.get('subjectId')
  // const watchType = query.get('watchType')
  // const [logo,setLogo] = useState('')
  // const [orderNum,setOrderNum] = useState('')
  // const getLogo = () => {
  //   get(`/shop/front/ge/column/subject/getDetail2?subjectId=${subjectId}${watchType ? '&watchType='+ watchType : ''}`,{},false).then(res=>{
  //     if(res.code === 0){
  //       setLogo(res.data.logoUrl)
  //       setOrderNum(res.data.orderNum)
  //     }
  //   })
  // }
  useEffect(()=>{
    console.log('----------回退检测---------------')
  },[])
  return (
    <>
        <div className={props.title ?` ${Style.header} tc pos-r` : Style.header}>
            <LeftOutline className={Style.back} onClick={()=>{
              isInApp()? props.location.pathName === '/' ||  props.location.pathName === '/index' ? webCallApp("CmdGoBack"): history.go(-1) : history.go(-1)
            }}/>  <div>{props.title ? props.title : ''}</div>
        </div>
    </>
  );
};
const mapStateToProps = (state:any) => ({
  InitPageData: state.InitPageData, // 映射仓库中的某个变量到组件的props
});
export default connect(mapStateToProps)(Header);

